var Conversation = (function(Conversation) {

  var tmpl = '<div class="cw-conversation-attachment"><img class="js-preview" src="%{preview}" /><strong>%{name}</strong> %{size} <span class="cw-close js-close">×</span></div>'

  // https://stackoverflow.com/a/38897674/508684
  function fileSize(size) {
    var e = (Math.log(size) / Math.log(1024)) | 0;
    return +(size / Math.pow(1024, e)).toFixed(2) + ' ' + ('kMGTPEZY'[e - 1] || '') + 'B';
  }

  function Attachment(file, sender, html) {
    this.sender = sender; // We keep a reference to enable the button when user deletes an attachment

    // special case to initialize with existing template
    if (!file && html) {
      this.html = html;
      this.fileMetadata = {
        id: this.html.data('id'),
        size: $.trim(this.html.find('[data-size]').text()),
        name: $.trim(this.html.find('[data-name]').text()),
        preview: this.html.find('[data-preview]').attr('src'),
        url: this.sender.attacher.data('url') + '/' + this.html.data('id')
      };

      console.log(this.fileMetadata);
    } else {
      this.file = file;

      this.fileMetadata = {
        name: file.name,
        type: file.type,
        size: fileSize(file.size),
        preview: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' // 1px transparent gif
      };

      this.buildHTML();
      this.buildPreview(file);

      this.uploadFile();
    }

    this.attachEvents();
  }

  Attachment.prototype.attachEvents = function() {
    this.close = this.html.find('.js-close');
    this.close.on('click', this.remove.bind(this));
  }

  Attachment.prototype.remove = function(removeFromServer) {
    if (removeFromServer === undefined) {
      removeFromServer = true;
    }

    this.html.remove();
    this.sender.enableUploader();
    this.sender.attacher.val('');
    if (this.fileMetadata.id && removeFromServer) {
      $.ajax({
        url: this.sender.attacher.data('url') + '/' + this.fileMetadata.id,
        method: 'delete'
      }).then(function() {
        delete this
      }.bind(this));
    } else {
      delete this;
    }
  }

  Attachment.prototype.buildHTML = function() {
    var html = tmpl.replace(/%\{(\w+)\}/g, function(_, key) {
      if (this.fileMetadata[key]) {
        return this.fileMetadata[key];
      }
      return key;
    }.bind(this));

    this.html = $(html);
  }

  Attachment.prototype.buildPreview = function(file) {
    this.preview = this.html.find('.js-preview');
    if (this.fileMetadata.type === 'application/pdf') {
      this.fileMetadata.preview = '/images/icons/pdf.png';
      this.preview.attr('src', this.fileMetadata.preview);
    } else {
      var reader = new FileReader();
      reader.addEventListener('load', function() {
        this.fileMetadata.preview = reader.result;
        this.preview.attr('src', reader.result);
      }.bind(this));

      reader.readAsDataURL(file);
    }
  }

  Attachment.prototype.uploadFile = function() {
    var data = new FormData();
    data.append('file', this.file, this.file.name);

    $.ajax({
      url: this.sender.attacher.data('url'),
      data: data,
      method: 'post',
      processData: false,
      cache: false,
      contentType: false,
    }).success(function(res) {
      this.fileMetadata.id = res.id;
      this.fileMetadata.url = this.sender.attacher.data('url') + '/' + res.id;
    }.bind(this)).fail(function(err) {
      this.remove();
      window.alert(I18n.translate('error_has_occured_please_try_again'));
    }.bind(this));
  }

  Attachment.prototype.render = function() {
    return this.html;
  }

  Conversation.Attachment = Attachment;
  return Conversation;
})(Conversation || {});
